/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Deep_P3Inputs */

const en_viewer_deep_p3 = /** @type {(inputs: Viewer_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first two levels are expanded when a document loads and everything deeper starts collapsed. That is a deliberate compromise: expanding everything makes a large response unreadable and slow to render, while collapsing everything means clicking before you can see anything at all. Two levels is usually enough to show the shape of a response and the names of its top level fields.`)
};

const ko_viewer_deep_p3 = /** @type {(inputs: Viewer_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서를 불러오면 처음 두 단계가 펼쳐지고 그보다 깊은 것은 접힌 상태로 시작합니다. 이는 의도된 타협입니다. 전부 펼치면 큰 응답이 읽을 수 없고 렌더링도 느려지며, 전부 접으면 무엇이든 보기 전에 클릭을 해야 합니다. 두 단계면 보통 응답의 형태와 최상위 필드의 이름을 보여주기에 충분합니다.`)
};

const ja_viewer_deep_p3 = /** @type {(inputs: Viewer_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書を読み込むと最初の 2 段階が展開され、それより深いものは折りたたまれた状態で始まります。これは意図的な妥協です。すべて展開すると大きなレスポンスは読めずレンダリングも遅くなり、すべて折りたたむと何かを見る前にクリックが必要になります。2 段階あれば通常、レスポンスの形と最上位フィールドの名前を示すのに十分です。`)
};

/**
* | output |
* | --- |
* | "The first two levels are expanded when a document loads and everything deeper starts collapsed. That is a deliberate compromise: expanding everything makes a..." |
*
* @param {Viewer_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_deep_p3 = /** @type {((inputs?: Viewer_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_deep_p3(inputs)
	if (locale === "ko") return ko_viewer_deep_p3(inputs)
	return ja_viewer_deep_p3(inputs)
});